import { render } from "./realNameFail.vue?vue&type=template&id=59fc5aa4&scoped=true"
import script from "./realNameFail.vue?vue&type=script&lang=js"
export * from "./realNameFail.vue?vue&type=script&lang=js"

import "./realNameFail.vue?vue&type=style&index=0&id=59fc5aa4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_T3ED/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fc5aa4"]])

export default __exports__